import React from 'react'
import { Link } from 'react-router-dom'
import { TextField } from 'admin-on-rest'

const AccountLinkField = ( props ) => {
	const { record = {} } = props
	if ( record.id ) {
		return (
			<Link to={{ pathname: `accounts/${record.id}`, }}>
				<TextField { ...props } />
			</Link>
		)
	} else {
		return <TextField { ...props } />
	}
}

export default AccountLinkField



// WEBPACK FOOTER //
// ./src/DCAccount/AccountLinkField.js